const MAILING_LIST_MODEL_CLASS_NAME = 'MailingList'

const MAILING_LIST_MODEL_KEY = {
  VALUE: 'value'
}

const MAILING_LIST_MODEL_PLACEHOLDER = {
  [MAILING_LIST_MODEL_KEY.VALUE]: 'example@mg.gymaholic.co'
}

export {
  MAILING_LIST_MODEL_CLASS_NAME,
  MAILING_LIST_MODEL_KEY,
  MAILING_LIST_MODEL_PLACEHOLDER
}
